import { getAuthParams } from '@/common/utils/login'
import env from '@/common/utils/env'
import { pick } from 'lodash'

export function paramsFormat (config) {
  config.params = Object.entries(config.params || {}).reduce((obj, item) => {
    if (item[1] !== '') {
      obj[item[0]] = item[1]
    }
    return obj
  }, {})
  if (config.method !== 'get') {
    config.data = config.params
    delete config.params
  } else {
    config.params[`t${new Date().getTime()}`] = 1
  }
  return config
}

/**
 * 识别gateway地址，自动转换请求配置
 * 将url替换成/gateway
 * 将api添加到params中
 */
export function transferConfig (url) {
  if (url.indexOf('http') !== -1 || url.indexOf('//:') !== -1) {
    return {
      transUrl: url,
      transParams: {}
    }
  }
  let transParams = {}
  let transUrl = url
  // eslint-disable-next-line no-useless-escape
  let isGatewayReg = (url.indexOf('.') !== -1)
  // eslint-disable-next-line no-useless-escape
  let isCommonGatewayReg = new RegExp('^common.', 'g')
  if (isGatewayReg) {
    if (isCommonGatewayReg.test(url)) {
      transUrl = '/common'
      transParams = {
        api: url
      }
    } else {
      transUrl = '/gateway'
      transParams = {
        api: url
      }
    }
  }
  return {
    transUrl,
    transParams
  }
}

/**
 * 获取公共参数
 * 用户的country, timezone, locale, ticket
 * @returns {{[p: string]: *}}
 */
export function getCommonParams() {
  const userInfo = env.get('userInfo')
  let userParams = pick(userInfo, ['country', 'timezone', 'locale'])
  return {
    ...getAuthParams(),
    ...userParams
  }
}
/**
 * @param {*} name 获取url问号后的参数
 * @returns
 */
export function getQueryString(name) { // 取url上的id
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(decodeURI(r[2]))
  return null
}
